import md5 from "md5";
import { getLayerIdByName } from "../lib/utils";

const initialState = {
  tree: window["appConfig"]
    ? [...window["appConfig"]().registeredLayerTree]
    : [],
  layers: {},
};
export default function RegisteredLayerTreeReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case "registeredLayerTree/state/tree/update":
      {
        let newState = { ...state };

        newState.tree = action.payload;
        return newState;
      }
      break;

    case "registeredLayerTree/state/layers/update":
      {
        let newState = { ...state };

        newState.layers = action.payload;
        return newState;
      }
      break;

    case "layer/registeredlayertree/add":
      {
        let newState = { ...state };

        newState.tree = [
          ...state.tree,
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "layer",
            expanded: true,
            checked: true,
            layer: action.payload,
          },
        ];

        newState.layers[action.payload.id] = action.payload;

        return newState;
      }
      break;

    case "layer/registeredlayertree/source/add":
      {
        let newState = { ...state };

        newState.tree = [
          ...state.tree,
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "service",
            expanded: true,
            checked: true,
            source: action.payload,
          },
        ];

        return newState;
      }
      break;

    case "registeredLayerTree/group/add":
      {
        let newState = { ...state };

        newState.tree = [
          ...state.tree,
          {
            id: action.payload.id,
            title: action.payload.title,
            type: "group",
            expanded: true,
            checked: true,
          },
        ];

        return newState;
      }

      break;

    default:
      {
        let newState = { ...state };

        function reccursive(data) {
          return data?.map((el) => {
            if (el.layer?.source.type !== "GEOJSON") {
              switch (el.type) {
                case "layer":
                  el.id = getLayerIdByName(el.layer.name, el.layer.source.url);
                  el.layer.id = getLayerIdByName(
                    el.layer.name,
                    el.layer.source.url
                  );
                  el.layer.source.id = md5(el.layer.source.url);
                  break;

                case "service":
                  el.id = md5(el.source.url);
                  el.source.id = md5(el.source.url);
                  break;
              }
            }

            reccursive(el.children);

            return el;
          });
        }

        return {
          layers: { ...state.layers },
          tree: reccursive(newState.tree),
        };
      }
      break;
  }
}
